import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  flex-direction: column;
  background-color: white;
  display: flex;
  align-items: center;
  overflow-x: hidden;
`;

export const S3ImageContainer = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  z-index: 9;
`;

export const S3Image = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const S3ImageBox = styled.div`
  align-content: center;
  max-width: 1280px;
  position: relative;
  width: 100%;
`;

export const S3ImageExitButton = styled.div`
  width: 40px;
  height: 40px;
  right: 10px;
  margin-top: 10px;
  gap: 10px;
  border-radius: 4px 4px 4px 4px;
  opacity: 60%;
  background-color: black;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;

  &::before {
    content: 'X';
  }
`;
export const BodyContainer = styled.div`
  background-color: white;
  width: 100%;
  max-width: 1280px;
  height: 100%;
`;

export const Header = styled.div`
  width: 100%;
  height: 56px;
  padding: 16px 20px 16px 20px;
  gap: 12px;
  border: 0px 0px 1px 0px;
  line-height: 24px;
  color: #25282f;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.02em;
  display: flex;
  align-items: center;
`;

export const ExpectTimeContainer = styled.div`
  background: #eeeeee;
  min-height: 136px;
  padding: 20px;
  width: 100%;
  gap: 10px;
`;

export const ExpectTimeBox = styled.div`
  min-height: 96px;
  min-width: 250px;
  padding: 16px 15px 16px 15px;
  gap: 4px;
  border-radius: 8px;
  border: 1px solid #d8ddea;
  background: #ffffff;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.02em;
`;

export const ProgressStatusIcon = styled.div`
  height: 24px;
  padding: 2px 8px 2px 8px;
  gap: 10px;
  border-radius: 4px;
  background-color: ${props => props.color};
  font-family: 'Pretendard';
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: white;
`;

export const InvoiceInfoContainer = styled.div`
  height: 144px;
  padding: 20px;
  min-width: 250px;
  gap: 4px;
  border-bottom: 1px solid #d8ddea;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const DeliveryInfoContainerWrapper = styled.div`
  padding: 12px 0px;
  align-items: center;
  background-color: white;
  position: relative;
`;

export const DeliveryInfoContainerDragBar = styled.div`
  width: 100px;
  height: 8px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  border-radius: 5px;
  background: var(--semantic-color-background-divider-2, #d5d8e1);
`;

export const DeliveryInfoContainer = styled.div`
  width: 100%;
  min-height: 400px;
  max-height: 472px;
  padding: 20px 20px 32px 20px;
  gap: 12px;
`;

export const InvoiceInfoWrapper = styled.div`
  display: flex;
  height: fit-content;
  flex-flow: row nowrap;
  word-break: keep-all;
`;
export const InvoiceInfoTitle = styled.div`
  width: 48px;
  height: fit-content;
  font-family: 'Pretendard';
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.02em;
  min-width: 48px;
  text-align: left;
  margin-right: 12px;
  color: #8f96a9;
`;
export const InvoiceInfo = styled.div`
  font-family: 'Pretendard';
  font-size: 14px;
  width: 100%;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.02em;
  word-wrap: break-word;
  text-align: left;
  color: #565b69;
`;

export const progressBar = styled.div<{ height: string }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 18px;
  height: ${props => (props.height ? props.height : '87px')};
`;

export const progressStep = styled.div`
  display: flex; /* ProgressBar와 ProgressContent를 가로로 나란히 배치 */
  flex-direction: row;
  gap: 10px; /* 두 요소 사이의 간격 추가 */
  min-height: 87px;
  width: auto;
`;

export const progressContentContainer = styled.div`
  width: inherit;
  height: 100%;
  overflow-x: hidden;
`;

export const progressTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 20.8px;
  letter-spacing: -0.02em;
  color: ${props => props.color};
`;

export const progressStatus = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: -0.02em;
  color: ${props => props.color};
`;

export const progressDatetime = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: -0.02em;
  color: ${props => props.color};
`;

export const IconButton = styled.button`
  display: flex;
  justify-content: center;
`;
